import React, { useEffect, useState } from 'react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Color from '@tiptap/extension-color'
import TextStyle from '@tiptap/extension-text-style'
import './TipTap.css'
import ImageResize from 'tiptap-extension-resize-image'
import Link from '@tiptap/extension-link'
import { Box } from '@mui/material'
import S3Image from './CustomImage'
import API from '../../services/API'
import MuiAlert from './components/MuiAlert'

const extensions = [
  MuiAlert,
  S3Image,
  StarterKit,
  Underline,
  // TextStyle.configure({
  //   HTMLAttributes: {
  //     style: '',
  //   },
  // }),
  Color,
  ImageResize,
  Link,
]

const TipTapReader = ({ content }) => {
  const [processedContent, setProcessedContent] = useState(null)

  useEffect(() => {
    if (!content) return

    const processImages = async () => {
      const subdomain = window.location.hostname.split('.')[0]

      // Replace placeholder before parsing content (but won't touch image src attrs directly)
      const withTenant = content.replace(/{{tenantSubdomain}}/g, subdomain)

      const parser = new DOMParser()
      const doc = parser.parseFromString(
        `<div>${withTenant}</div>`,
        'text/html',
      )

      // Only look for <img> tags with data-key for URL replacement
      const images = [...doc.querySelectorAll('img[data-key]')]

      const keys = [
        ...new Set(images.map((img) => img.getAttribute('data-key'))),
      ]
      const keyToUrl = {}

      for (const key of keys) {
        try {
          const res = await API.post('/kbdocs/image-download-url', {
            key,
            inlineView: true,
          })
          keyToUrl[key] = res.data
        } catch (err) {
          console.error('Failed to fetch signed URL for', key)
        }
      }

      // Replace the src on matching images only
      images.forEach((img) => {
        const key = img.getAttribute('data-key')
        if (keyToUrl[key]) {
          img.setAttribute('src', keyToUrl[key])
        }
      })

      setProcessedContent(doc.body.innerHTML)
    }

    processImages()
  }, [content])

  const editor = useEditor({
    content: processedContent,
    extensions,
    editable: false,
  })

  useEffect(() => {
    if (editor && processedContent && processedContent !== editor.getHTML()) {
      editor.commands.setContent(processedContent)
    }
  }, [processedContent, editor])

  if (!editor) return null

  return (
    <Box className="tiptap-reader">
      <EditorContent editor={editor} />
    </Box>
  )
}

export default TipTapReader
